export default "/static/dashboard/build/app/img/v2/565b401d6519acd5e9ec40b7af945672.png";